import rate from './rate';

export default {
  rate
};
